export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileVedooltasok');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileVedooltasok');
    }
}
